import * as S from './styles'
import { ToastBase } from 'src/components/ToastBase'
import { useState, useEffect } from 'react'
import { listenNotificationEvent } from 'src/events'

type IDataProps = {
  id?: string
  type?: 'error' | 'info' | 'success'
  title?: string
  message?: string
  children?: React.ReactNode
  isIndeterminate?: boolean
  textButton?: string
  customButton?: string
  onClick?: (id: string | undefined) => void
  onClose?: (id: string | undefined) => void
}

const ToastProvider = () => {
  const [notifications, setNotifications] = useState<any[]>([])

  const handleCloseToast = (item: IDataProps) => {
    const filteredToast = notifications?.filter(
      (f: IDataProps) => f.id !== item.id
    )
    setNotifications(filteredToast)
    item.onClose && item.onClose(item.id)
  }

  useEffect(() => {
    listenNotificationEvent((event: any) =>
      setNotifications((n) => [...n, event.detail])
    )
  }, [])

  return (
    <S.Wrapper data-testid="ToastProvider">
      {notifications?.length ? (
        notifications
          .filter(
            (object, index, self) =>
              index === self.findIndex((t) => t.id === object.id)
          )
          .map((item, index) => (
            <ToastBase
              data-testid="toast"
              key={index}
              id={item.id}
              type={item.type}
              title={item.title}
              message={item.message}
              textButton={item.textButton}
              customButton={item?.customButton}
              isIndeterminate={item?.isIndeterminate}
              onClick={() => item?.onClick && item.onClick(item.id)}
              onClose={() => handleCloseToast(item)}
            >
              {item.children}
            </ToastBase>
          ))
      ) : (
        <></>
      )}
    </S.Wrapper>
  )
}

export { ToastProvider }
